import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  const navItems = [
    { path: '/', label: t.nav.about },
    { path: '/services', label: t.nav.services },
    { path: '/distribution', label: t.nav.distribution },
    { path: '/trading', label: t.nav.trading },
    { path: '/contact', label: t.nav.contact },
  ];

  return (
    <footer className="bg-[#003840] text-white border-t-2 border-[#007369]/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_flour-global-market/artifacts/pjgumxga_Aria_Logo_White.png"
                alt="Aria MEA"
                className="h-10"
              />
              <span className="text-2xl font-bold text-white">Aria MEA</span>
            </div>
            <p className="text-gray-300 text-sm">{t.footer.description}</p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Navigation</h3>
            <nav className="space-y-2">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setTimeout(() => window.scrollTo(0, 0), 100)}
                  className="block text-gray-300 hover:text-[#008C72] transition-colors text-sm"
                >
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-lg mb-4">{t.contact.title}</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <Mail className="h-5 w-5 text-[#008C72] flex-shrink-0 mt-0.5" />
                <a
                  href="mailto:contact@ariamea.com"
                  className="text-gray-300 hover:text-[#008C72] transition-colors text-sm"
                >
                  contact@ariamea.com
                </a>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-[#008C72] flex-shrink-0 mt-0.5" />
                <p className="text-gray-300 text-sm">{t.contact.addressValue}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-700 text-center text-sm text-gray-400">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-2">
            <p>© {currentYear} ARIA MEA Ventures. {t.footer.rights}</p>
            <span className="hidden sm:inline">|</span>
            <Link to="/terms" onClick={() => setTimeout(() => window.scrollTo(0, 0), 100)} className="hover:text-[#008C72] transition-colors">
              {t.footer.terms}
            </Link>
          </div>
          <div className="mt-3">
            <p className="text-gray-500 text-xs">
              Creat de <a href="https://digital.marexon.com" target="_blank" rel="noopener noreferrer" className="text-[#008C72] hover:text-[#00A894] transition-colors">digital.marexon.com</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;